import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiBusinessUnitListState } from './states/business-unit-list-state';
import { FiBusinessUnitAddV2State } from './states/business-unit-add-state';
import { FiBusinessUnitEditV2State } from '@fi-app/business-unit/states/business-unit-edit-state';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

export const FiBusinessUnitRootState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessUnit._name,
    url: '/BusinessUnit',
    abstract: true,
    component: FiAbstractStateComponent,
};

export const FiBusinessUnitStates: StatesModule = {
    states: [FiBusinessUnitRootState, FiBusinessUnitListState, FiBusinessUnitAddV2State, FiBusinessUnitEditV2State],
};
